import Route from '@ember/routing/route';

export default class GroupsRoute extends Route {}
